import React from 'react';
import GlobalCtx from '@components/globalContext';
import { Controls, LayoutType } from '@components';

const Image = (): JSX.Element => {
  const { image, app } = React.useContext(GlobalCtx);
  if (!image.imageContent) {
    return;
  }

  const { mod, previewMod, previewSrc, src } = image.imageContent;
  const srcImagePath = () => {
    const imagePath = previewSrc || src;
    return imagePath;
  };

  const modImagePath = () => {
    const imagePath = previewMod || mod;
    return imagePath;
  };

  return (
    <div className="bg-white shadow-md p-4 border border-sky-100 place-content-center rounded">
      <div className="grid md:grid-cols-4 md:gap-6">
        <div className="md:col-span-3 flex">
          <div className="place-self-center w-full">
            <div className="grid grid-cols-2 gap-2">
              <div className={app.layout === 'SIDE_BY_SIDE' ? '' : 'col-span-2'}>
                <img src={modImagePath()} alt="modified image" className="image" />
              </div>
              {app.layout === 'SIDE_BY_SIDE' ? (
                <div>
                  <img src={srcImagePath()} alt="source image" className="image" />
                </div>
              ) : (
                ''
              )}
            </div>
            <LayoutType />
          </div>
        </div>
        <Controls />
      </div>
    </div>
  );
};

export default Image;
